import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { USER_TYPES } from '@constants/userTypes.ts';
import { useAppSelector } from '@hooks/reduxHooks.ts';
import { useLingui } from '@lingui/react/macro';
import { AvatarImg } from '@routes/profile-bar/___shared___/components/avatar';
import { getProfileHeaderData } from '@routes/profile-bar/___shared___/helpers.ts';
import { FallbackAvatarWrapper } from '@routes/profile-bar/___shared___/styled.tsx';
import ProfileHeaderNoData from '@routes/sidebar/___shared___/components/profile-header-no-data';

import {
    UserProfileDetailsWrapper,
    UserProfileHeader,
    UserProfileHeaderInfo,
    UserProfileHeaderInfoAvatar,
    UserProfileHeaderInfoItem,
    UserProfileHeaderInfoName,
} from './styled.tsx';

const ProfileHeader: React.FC = () => {
    const { t } = useLingui();
    const userInfo = useAppSelector((state) => state.user.userInfo);
    const clientDetails = useAppSelector((state) => state.clientDetails.clientDetails);

    if (!userInfo) return <ProfileHeaderNoData />;

    const { firstName, lastName, avatarURI } = userInfo.userPersonalData;
    const isCrewUser = userInfo?.userType === USER_TYPES.Crew;
    const { rank, location, isOnboard, titleName } = getProfileHeaderData(clientDetails, userInfo, isCrewUser);
    const onboardVessel = isOnboard && location ? location : t`Unassigned`;

    return (
        <UserProfileHeader>
            <UserProfileHeaderInfo>
                <UserProfileHeaderInfoAvatar>
                    {avatarURI ? (
                        <AvatarImg avatarURI={avatarURI} />
                    ) : (
                        <FallbackAvatarWrapper>
                            <UserOutlined />
                        </FallbackAvatarWrapper>
                    )}
                </UserProfileHeaderInfoAvatar>
                <UserProfileDetailsWrapper>
                    <UserProfileHeaderInfoName>
                        {firstName} {lastName}
                    </UserProfileHeaderInfoName>
                    <UserProfileHeaderInfoItem>{isCrewUser ? rank : titleName}</UserProfileHeaderInfoItem>
                    {!!isCrewUser && (
                        <UserProfileHeaderInfoItem>{t`Onboard Vessel: ${onboardVessel}`}</UserProfileHeaderInfoItem>
                    )}
                </UserProfileDetailsWrapper>
            </UserProfileHeaderInfo>
        </UserProfileHeader>
    );
};

export default ProfileHeader;
